import { Fragment } from "react";
import LinkWrap from "../../../../components/LinkWrap/component";
import {
    isAbsoluteUrl,
    removeUrlDomain,
} from "../../../../utils/path/library.js";

export const AuthorList = (props) => {
    if (!props.authorList || !props.authorList.length) {
        return null;
    }

    return (
        <span
            className="authorText"
            data-testid="author-text"
            data-cy="author-text"
        >
            {props.authorList.map((author, index) => {
                const delimiter = index + 1 !== props.authorList.length && ", ";

                let authorURL;

                if (author.url && typeof author.url === "string") {
                    authorURL = removeUrlDomain(author.url);
                    authorURL = !authorURL ? "/" : authorURL; // homepage
                }

                return (
                    <Fragment key={`${author.name}-${index}`}>
                        {authorURL ? (
                            <LinkWrap
                                url={authorURL}
                                external={!!isAbsoluteUrl(authorURL)}
                            >
                                {author.name}
                            </LinkWrap>
                        ) : (
                            author.name
                        )}
                        {delimiter}
                    </Fragment>
                );
            })}
        </span>
    );
};
